import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Phone, MapPin, Clock } from 'lucide-react';

const MapSection = () => {
  return (
    <section className="section-padding bg-gray-50">
      <div className="container mx-auto">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
            Get a Free Estimate for Pressure Washing Near Me
          </h2>
          <p className="text-xl text-gray-600 text-center mb-12 max-w-3xl mx-auto">
            Serving all of Ventura County with professional pressure washing, window cleaning, and exterior cleaning services. Find us easily and schedule your free estimate today!
          </p>
          
          <div className="grid lg:grid-cols-2 gap-8 items-stretch">
            {/* Google Maps Embed */}
            <div className="w-full">
              <div className="bg-white rounded-lg shadow-lg overflow-hidden h-full">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d211815.95782778868!2d-119.39207644843748!3d34.39564130000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80e847c8f7f2e7c7%3A0x1e4b8e3e8e3e3e3e!2sVentura%20County%2C%20CA!5e0!3m2!1sen!2sus!4v1697544543021!5m2!1sen!2sus"
                  width="100%"
                  height="100%"
                  style={{ border: 0, minHeight: '400px' }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Ventura Power Washing Service Area Map"
                  className="w-full h-full"
                />
              </div>
            </div>
            
            {/* Contact Information Card */}
            <div>
              <Card className="shadow-lg h-full">
                <CardContent className="p-6 flex flex-col justify-between h-full">
                  <div>
                    <h3 className="text-2xl font-bold mb-6 text-primary">Contact Ventura Power Washing</h3>
                    
                    <div className="space-y-4">
                      <div className="flex items-center">
                        <Phone className="h-6 w-6 text-primary mr-4" />
                        <div>
                          <p className="font-semibold">Phone</p>
                          <a href="tel:+18054647166" className="text-primary hover:underline text-lg">
                            (805) 464-7166
                          </a>
                        </div>
                      </div>
                      
                      <div className="flex items-center">
                        <MapPin className="h-6 w-6 text-primary mr-4" />
                        <div>
                          <p className="font-semibold">Service Area</p>
                          <p className="text-gray-600">
                            Serving all of Ventura County, CA
                          </p>
                          <p className="text-sm text-gray-500 mt-1">
                            Camarillo, Fillmore, Moorpark, Oxnard, Port Hueneme, Santa Paula, Simi Valley, Thousand Oaks, and Ventura
                          </p>
                        </div>
                      </div>
                      
                      <div className="flex items-center">
                        <Clock className="h-6 w-6 text-primary mr-4" />
                        <div>
                          <p className="font-semibold">Business Hours</p>
                          <p className="text-gray-600">Monday - Saturday: 7:00 AM - 7:00 PM</p>
                          <p className="text-gray-600">Sunday: Available for emergencies</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="mt-6 pt-6 border-t">
                    <Button 
                      className="w-full button-primary text-lg py-6"
                      onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                    >
                      Get Your Free Estimate Now
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
          
          <div className="mt-8 text-center">
            <h4 className="text-lg font-semibold mb-4">Popular Areas We Serve</h4>
            <div className="flex flex-wrap justify-center gap-3">
              {[
                { label: 'Pressure Washing Ventura', to: '/ventura' },
                { label: 'Window Cleaning Camarillo', to: '/camarillo' },
                { label: 'Carpet Cleaning Oxnard', to: '/oxnard' },
                { label: 'Soft Wash Thousand Oaks', to: '/thousand-oaks' },
                { label: 'Gutter Cleaning Simi Valley', to: '/simi-valley' },
                { label: 'Solar Panel Cleaning Moorpark', to: '/moorpark' },
              ].map((area) => (
                <Link
                  key={area.to}
                  to={area.to}
                  className="bg-ventura-blue/10 text-ventura-blue hover:bg-ventura-blue/20 px-5 py-2 rounded-full text-sm font-medium transition-colors"
                >
                  {area.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapSection;